
import {executeCallback} from './functions';

class Cycle{

    constructor(){
        const requestAnimationFrame = (function(){
            return window.requestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.oRequestAnimationFrame ||
                    window.msRequestAnimationFrame ||
                    function(callback){
                        window.setTimeout(callback, 1000/30);
                    };
        })();

        const cycle = this;
        this.nextCycle = function(){
            requestAnimationFrame.call(window, function(){
                cycle.tick.call(cycle);
            });
        }

        this.listeners = new Set();
        this.time = Date.now();
        this.nextCycle();
        this.tmp = [];
    }

    tick(){
        let d = Date.now();
        let delta = d - this.time;
        this.time = d;

        for(let callback of this.listeners){
            executeCallback(callback, [delta]);
        }

        this.nextCycle();
    }

    addListener(callback){
        this.tmp = callback;
        this.listeners.add(callback);
    }

    removeListener(callback){
        return this.listeners.delete(callback);
    }

}

class LifeCycle{

    constructor(callback, duration, easing='linear'){
        this.callback = callback;
        this.duration = duration;
        this.easing = easing;
        this.progress = 0;
        this.onFinish = [];
        this.localCallback = [this, this.tick];

    }

    start(){
        cycle.addListener(this.localCallback);
    }

    addFinishCallback(callback){
        this.onFinish.push(callback);
    }

    tick(delta){
        if(this.callback){
            this.progress += delta;
            let fact = this.applyEasing(Math.min(1, this.progress / this.duration));
            executeCallback(this.callback, [fact]);
            if(fact == 1){
                this.finish();
            }
        }
    }

    finish(){
        if(this.onFinish){
            let callbacks = this.onFinish.splice(0);
            for(let callback of callbacks){
                executeCallback(callback, []);
            }
        }
        this.remove();
    }

    remove(){

        let result = cycle.removeListener(this.localCallback);
        
        delete this.callback;
        delete this.localCallback;
        delete this.duration;
        delete this.progress;
        delete this.onFinish;
    }

    applyEasing(fact){
        if(this.easing === 'linear'){
            return fact;
        }else if(this.easing === 'cubic' || this.easing === 'easeout'){
            return Math.sqrt(fact);
        }else if(this.easing === 'easein'){
            return fact*fact;
        }else if(this.easing == 'exp' || this.easing == 'expout'){
            return ( -Math.pow( 2, -10 * fact ) + 1 );
        }
        return fact;
    }

}


let cycle = new Cycle();
export default cycle;
export {LifeCycle};